var items = {
  "block.minecraft.air": "luft",
  "block.minecraft.stone": "stein",
  "block.minecraft.granite": "granitt",
  "block.minecraft.polished_granite": "finpussa granitt",
  "block.minecraft.diorite": "dioritt",
  "block.minecraft.polished_diorite": "finpussa dioritt",
  "block.minecraft.andesite": "andesitt",
  "block.minecraft.polished_andesite": "finpussa andesitt",
  "block.minecraft.grass_block": "grasblokk",
  "block.minecraft.dirt": "mold",
  "block.minecraft.coarse_dirt": "grov mold",
  "block.minecraft.podzol": "podsol",
  "block.minecraft.crimson_nylium": "blodnycel",
  "block.minecraft.warped_nylium": "vride nycel",
  "block.minecraft.cobblestone": "brustein",
  "block.minecraft.oak_planks": "eikeplankar",
  "block.minecraft.spruce_planks": "granplankar",
  "block.minecraft.birch_planks": "bjørkeplankar",
  "block.minecraft.jungle_planks": "jungeltreplankar",
  "block.minecraft.acacia_planks": "akasieplankar",
  "block.minecraft.dark_oak_planks": "mørkeikeplankar",
  "block.minecraft.crimson_planks": "blodplankar",
  "block.minecraft.warped_planks": "vridne plankar",
  "block.minecraft.oak_sapling": "eikefrø",
  "block.minecraft.spruce_sapling": "granfrø",
  "block.minecraft.birch_sapling": "bjørkefrø",
  "block.minecraft.jungle_sapling": "jungeltrefrø",
  "block.minecraft.acacia_sapling": "akasiefrø",
  "block.minecraft.dark_oak_sapling": "mørkeikefrø",
  "block.minecraft.bedrock": "berggrunn",
  "block.minecraft.sand": "sand",
  "block.minecraft.red_sand": "raud sand",
  "block.minecraft.gravel": "grus",
  "block.minecraft.gold_ore": "gullmalm",
  "block.minecraft.iron_ore": "jarnmalm",
  "block.minecraft.coal_ore": "kolmalm",
  "block.minecraft.nether_gold_ore": "nethergullmalm",
  "block.minecraft.oak_log": "eikestomn",
  "block.minecraft.spruce_log": "granstomn",
  "block.minecraft.birch_log": "bjørkestomn",
  "block.minecraft.jungle_log": "jungeltrestomn",
  "block.minecraft.acacia_log": "akasiestomn",
  "block.minecraft.dark_oak_log": "mørkeikestomn",
  "block.minecraft.crimson_stem": "blodstomn",
  "block.minecraft.warped_stem": "vriden stomn",
  "block.minecraft.stripped_oak_log": "slinda eikestomn",
  "block.minecraft.stripped_spruce_log": "slinda granstomn",
  "block.minecraft.stripped_birch_log": "slinda bjørkestomn",
  "block.minecraft.stripped_jungle_log": "slinda jungeltrestomn",
  "block.minecraft.stripped_acacia_log": "slinda akasiestomn",
  "block.minecraft.stripped_dark_oak_log": "slinda mørkeikestomn",
  "block.minecraft.stripped_crimson_stem": "slinda blodstomn",
  "block.minecraft.stripped_warped_stem": "slinda vriden stomn",
  "block.minecraft.stripped_oak_wood": "slinda eikeved",
  "block.minecraft.stripped_spruce_wood": "slinda granved",
  "block.minecraft.stripped_birch_wood": "slinda bjørkeved",
  "block.minecraft.stripped_jungle_wood": "slinda jungelved",
  "block.minecraft.stripped_acacia_wood": "slinda akasieved",
  "block.minecraft.stripped_dark_oak_wood": "slinda mørkeikeved",
  "block.minecraft.stripped_crimson_hyphae": "slinda blodhyfar",
  "block.minecraft.stripped_warped_hyphae": "slinda vridne hyfar",
  "block.minecraft.oak_wood": "eiketre",
  "block.minecraft.spruce_wood": "grantre",
  "block.minecraft.birch_wood": "bjørketre",
  "block.minecraft.jungle_wood": "jungeltre",
  "block.minecraft.acacia_wood": "akasietre",
  "block.minecraft.dark_oak_wood": "mørkeiketre",
  "block.minecraft.crimson_hyphae": "blodhyfar",
  "block.minecraft.warped_hyphae": "vridne hyfar",
  "block.minecraft.oak_leaves": "eikelauv",
  "block.minecraft.spruce_leaves": "granbar",
  "block.minecraft.birch_leaves": "bjørkelauv",
  "block.minecraft.jungle_leaves": "jungellauv",
  "block.minecraft.acacia_leaves": "akasielauv",
  "block.minecraft.dark_oak_leaves": "mørkeikelauv",
  "block.minecraft.sponge": "svamp",
  "block.minecraft.wet_sponge": "våt svamp",
  "block.minecraft.glass": "glas",
  "block.minecraft.lapis_ore": "malm av lasurstein",
  "block.minecraft.lapis_block": "blokk av lasurstein",
  "block.minecraft.dispenser": "utskytar",
  "block.minecraft.sandstone": "sandstein",
  "block.minecraft.chiseled_sandstone": "forma sandstein",
  "block.minecraft.cut_sandstone": "skoren sandstein",
  "block.minecraft.note_block": "noteblokk",
  "block.minecraft.powered_rail": "straumskjene",
  "block.minecraft.detector_rail": "detektorskjene",
  "block.minecraft.sticky_piston": "klisterstempel",
  "block.minecraft.cobweb": "spinn",
  "block.minecraft.grass": "gras",
  "block.minecraft.fern": "burkne",
  "block.minecraft.dead_bush": "daud busk",
  "block.minecraft.seagrass": "sjøgras",
  "block.minecraft.sea_pickle": "sjøagurk",
  "block.minecraft.piston": "stempel",
  "block.minecraft.white_wool": "kvit ull",
  "block.minecraft.orange_wool": "oransje ull",
  "block.minecraft.magenta_wool": "ljoslilla ull",
  "block.minecraft.light_blue_wool": "ljosblå ull",
  "block.minecraft.yellow_wool": "gul ull",
  "block.minecraft.lime_wool": "limegrøn ull",
  "block.minecraft.pink_wool": "rosa ull",
  "block.minecraft.gray_wool": "grå ull",
  "block.minecraft.light_gray_wool": "ljosgrå ull",
  "block.minecraft.cyan_wool": "blågrøn ull",
  "block.minecraft.purple_wool": "lilla ull",
  "block.minecraft.blue_wool": "blå ull",
  "block.minecraft.brown_wool": "brun ull",
  "block.minecraft.green_wool": "grøn ull",
  "block.minecraft.red_wool": "raud ull",
  "block.minecraft.black_wool": "svart ull",
  "block.minecraft.dandelion": "løvetann",
  "block.minecraft.poppy": "valmue",
  "block.minecraft.blue_orchid": "blå orkidé",
  "block.minecraft.allium": "villauk",
  "block.minecraft.azure_bluet": "houstonia",
  "block.minecraft.red_tulip": "raud tulipan",
  "block.minecraft.orange_tulip": "oransje tulipan",
  "block.minecraft.white_tulip": "kvit tulipan",
  "block.minecraft.pink_tulip": "rosa tulipan",
  "block.minecraft.oxeye_daisy": "prestekrage",
  "block.minecraft.cornflower": "kornblom",
  "block.minecraft.lily_of_the_valley": "rams",
  "block.minecraft.wither_rose": "witherrose",
  "block.minecraft.brown_mushroom": "brun sopp",
  "block.minecraft.red_mushroom": "raud sopp",
  "block.minecraft.crimson_fungus": "blodsopp",
  "block.minecraft.warped_fungus": "vriden sopp",
  "block.minecraft.crimson_roots": "blodrøter",
  "block.minecraft.warped_roots": "vridne røter",
  "block.minecraft.nether_sprouts": "netherspirer",
  "block.minecraft.weeping_vines": "gråtande klivevokster",
  "block.minecraft.twisting_vines": "krokande klivevokster",
  "block.minecraft.sugar_cane": "sukkerrøyr",
  "block.minecraft.kelp": "tare",
  "block.minecraft.bamboo": "bambus",
  "block.minecraft.gold_block": "gullblokk",
  "block.minecraft.iron_block": "jarnblokk",
  "block.minecraft.oak_slab": "eikehelle",
  "block.minecraft.spruce_slab": "granhelle",
  "block.minecraft.birch_slab": "bjørkehelle",
  "block.minecraft.jungle_slab": "jungeltrehelle",
  "block.minecraft.acacia_slab": "akasiehelle",
  "block.minecraft.dark_oak_slab": "mørkeikehelle",
  "block.minecraft.crimson_slab": "blodhelle",
  "block.minecraft.warped_slab": "vriden helle",
  "block.minecraft.stone_slab": "steinhelle",
  "block.minecraft.smooth_stone_slab": "glatt steinhelle",
  "block.minecraft.sandstone_slab": "sandsteinhelle",
  "block.minecraft.cut_sandstone_slab": "helle av skoren sandstein",
  "block.minecraft.petrified_oak_slab": "forsteina eikehelle",
  "block.minecraft.cobblestone_slab": "brusteinhelle",
  "block.minecraft.brick_slab": "murhelle",
  "block.minecraft.stone_brick_slab": "steinmurhelle",
  "block.minecraft.nether_brick_slab": "helle av nethermur",
  "block.minecraft.quartz_slab": "helle av kvarts",
  "block.minecraft.red_sandstone_slab": "raud sandsteinhelle",
  "block.minecraft.cut_red_sandstone_slab": "helle av skoren raud sandstein",
  "block.minecraft.purpur_slab": "purpurhelle",
  "block.minecraft.prismarine_slab": "prismarinhelle",
  "block.minecraft.prismarine_brick_slab": "prismarinmurhelle",
  "block.minecraft.dark_prismarine_slab": "mørk prismarinhelle",
  "block.minecraft.smooth_quartz": "glatt kvartsblokk",
  "block.minecraft.smooth_red_sandstone": "glatt raud sandstein",
  "block.minecraft.smooth_sandstone": "glatt sandstein",
  "block.minecraft.smooth_stone": "glatt stein",
  "block.minecraft.bricks": "murstein",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "bokhylle",
  "block.minecraft.mossy_cobblestone": "mosegrodd brustein",
  "block.minecraft.obsidian": "obsidian",
  "block.minecraft.torch": "fakkel",
  "block.minecraft.end_rod": "endestong",
  "block.minecraft.chorus_plant": "korvokster",
  "block.minecraft.chorus_flower": "korblome",
  "block.minecraft.purpur_block": "purpurblokk",
  "block.minecraft.purpur_pillar": "purpursøyle",
  "block.minecraft.purpur_stairs": "purpurtrapp",
  "block.minecraft.spawner": "framkallar",
  "block.minecraft.oak_stairs": "eiketrapp",
  "block.minecraft.chest": "kiste",
  "block.minecraft.diamond_ore": "diamantmalm",
  "block.minecraft.diamond_block": "diamantblokk",
  "block.minecraft.crafting_table": "arbeidsbord",
  "block.minecraft.farmland": "åker",
  "block.minecraft.furnace": "smelteomn",
  "block.minecraft.ladder": "stige",
  "block.minecraft.rail": "skjene",
  "block.minecraft.cobblestone_stairs": "brusteintrapp",
  "block.minecraft.lever": "spak",
  "block.minecraft.stone_pressure_plate": "steintrykkplate",
  "block.minecraft.oak_pressure_plate": "eiketrykkplate",
  "block.minecraft.spruce_pressure_plate": "grantrykkplate",
  "block.minecraft.birch_pressure_plate": "bjørketrykkplate",
  "block.minecraft.jungle_pressure_plate": "jungeltretrykkplate",
  "block.minecraft.acacia_pressure_plate": "akasietrykkplate",
  "block.minecraft.dark_oak_pressure_plate": "mørkeiketrykkplate",
  "block.minecraft.crimson_pressure_plate": "blodtrykkplate",
  "block.minecraft.warped_pressure_plate": "vriden trykkplate",
  "block.minecraft.polished_blackstone_pressure_plate": "trykkplate av finpussa svartstein",
  "block.minecraft.redstone_ore": "redstone-malm",
  "block.minecraft.redstone_torch": "redstone-fakkel",
  "block.minecraft.snow": "snø",
  "block.minecraft.ice": "is",
  "block.minecraft.snow_block": "snøblokk",
  "block.minecraft.cactus": "kaktus",
  "block.minecraft.clay": "leire",
  "block.minecraft.jukebox": "platespelar",
  "block.minecraft.oak_fence": "gjerde av eik",
  "block.minecraft.spruce_fence": "gjerde av gran",
  "block.minecraft.birch_fence": "gjerde av bjørk",
  "block.minecraft.jungle_fence": "gjerde av jungeltre",
  "block.minecraft.acacia_fence": "gjerde av akasietre",
  "block.minecraft.dark_oak_fence": "gjerde av mørkeik",
  "block.minecraft.crimson_fence": "blodgjerde",
  "block.minecraft.warped_fence": "vride gjerde",
  "block.minecraft.pumpkin": "graskar",
  "block.minecraft.carved_pumpkin": "utskore graskar",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "sjelesand",
  "block.minecraft.soul_soil": "sjelemold",
  "block.minecraft.basalt": "basalt",
  "block.minecraft.polished_basalt": "finpussa basalt",
  "block.minecraft.soul_torch": "sjelefakkel",
  "block.minecraft.glowstone": "glødestein",
  "block.minecraft.jack_o_lantern": "graskarlykt",
  "block.minecraft.oak_trapdoor": "eikelem",
  "block.minecraft.spruce_trapdoor": "granlem",
  "block.minecraft.birch_trapdoor": "bjørkelem",
  "block.minecraft.jungle_trapdoor": "jungeltrelem",
  "block.minecraft.acacia_trapdoor": "akasielem",
  "block.minecraft.dark_oak_trapdoor": "mørkeikelem",
  "block.minecraft.crimson_trapdoor": "blodlem",
  "block.minecraft.warped_trapdoor": "vriden lem",
  "block.minecraft.infested_stone": "fengd stein",
  "block.minecraft.infested_cobblestone": "fengd brustein",
  "block.minecraft.infested_stone_bricks": "fengd steinmur",
  "block.minecraft.infested_mossy_stone_bricks": "fengd mosegrodd steinmur",
  "block.minecraft.infested_cracked_stone_bricks": "fengd sprokken steinmur",
  "block.minecraft.infested_chiseled_stone_bricks": "fengd forma steinmur",
  "block.minecraft.stone_bricks": "steinmur",
  "block.minecraft.mossy_stone_bricks": "mosegrodd steinmur",
  "block.minecraft.cracked_stone_bricks": "sprokken steinmur",
  "block.minecraft.chiseled_stone_bricks": "forma steinmur",
  "block.minecraft.brown_mushroom_block": "brun soppblokk",
  "block.minecraft.red_mushroom_block": "raud soppblokk",
  "block.minecraft.mushroom_stem": "soppstilk",
  "block.minecraft.iron_bars": "gitter",
  "block.minecraft.chain": "kjede",
  "block.minecraft.glass_pane": "glasrute",
  "block.minecraft.melon": "melon",
  "block.minecraft.vine": "klivevokster",
  "block.minecraft.oak_fence_gate": "grind av eik",
  "block.minecraft.spruce_fence_gate": "grind av gran",
  "block.minecraft.birch_fence_gate": "grind av bjørk",
  "block.minecraft.jungle_fence_gate": "grind av jungeltre",
  "block.minecraft.acacia_fence_gate": "grind av akasietre",
  "block.minecraft.dark_oak_fence_gate": "grind av mørkeik",
  "block.minecraft.crimson_fence_gate": "blodgrind",
  "block.minecraft.warped_fence_gate": "vriden grind",
  "block.minecraft.brick_stairs": "murtrapp",
  "block.minecraft.stone_brick_stairs": "steinmurtrapp",
  "block.minecraft.mycelium": "mycel",
  "block.minecraft.lily_pad": "liljeblad",
  "block.minecraft.nether_bricks": "nethertegl",
  "block.minecraft.cracked_nether_bricks": "sprokke nethertegl",
  "block.minecraft.chiseled_nether_bricks": "forma nethertegl",
  "block.minecraft.nether_brick_fence": "gjerde av nethertegl",
  "block.minecraft.nether_brick_stairs": "trapp av nethertegl",
  "block.minecraft.enchanting_table": "galdrebord",
  "block.minecraft.end_portal_frame": "endeportalramme",
  "block.minecraft.end_stone": "endestein",
  "block.minecraft.end_stone_bricks": "endesteinstegl",
  "block.minecraft.dragon_egg": "drakeegg",
  "block.minecraft.redstone_lamp": "redstone-lampe",
  "block.minecraft.sandstone_stairs": "sandsteintrapp",
  "block.minecraft.emerald_ore": "smaragdmalm",
  "block.minecraft.ender_chest": "enderkiste",
  "block.minecraft.tripwire_hook": "snubletrådfeste",
  "block.minecraft.emerald_block": "smaragdblokk",
  "block.minecraft.spruce_stairs": "grantrapp",
  "block.minecraft.birch_stairs": "bjørketrapp",
  "block.minecraft.jungle_stairs": "jungeltretrapp",
  "block.minecraft.crimson_stairs": "blodtrapp",
  "block.minecraft.warped_stairs": "vriden trapp",
  "block.minecraft.command_block": "kommandoblokk",
  "block.minecraft.beacon": "varde",
  "block.minecraft.cobblestone_wall": "brusteinsmur",
  "block.minecraft.mossy_cobblestone_wall": "mosegrodd brusteinsmur",
  "block.minecraft.brick_wall": "teglmur",
  "block.minecraft.prismarine_wall": "prismarinmur",
  "block.minecraft.red_sandstone_wall": "raud sandsteinsmur",
  "block.minecraft.mossy_stone_brick_wall": "mosegrodd mur av steintegl",
  "block.minecraft.granite_wall": "granittmur",
  "block.minecraft.stone_brick_wall": "mur av steintegl",
  "block.minecraft.nether_brick_wall": "mur av nethertegl",
  "block.minecraft.andesite_wall": "andesittmur",
  "block.minecraft.red_nether_brick_wall": "mur av raudt nethertegl",
  "block.minecraft.sandstone_wall": "sandsteinmur",
  "block.minecraft.end_stone_brick_wall": "mur av endesteinstegl",
  "block.minecraft.diorite_wall": "diorittmur",
  "block.minecraft.blackstone_wall": "svartsteinsmur",
  "block.minecraft.polished_blackstone_wall": "mur av finpussa svartstein",
  "block.minecraft.polished_blackstone_brick_wall": "mur av finpussa svartsteinstegl",
  "block.minecraft.stone_button": "steinknapp",
  "block.minecraft.oak_button": "eikeknapp",
  "block.minecraft.spruce_button": "granknapp",
  "block.minecraft.birch_button": "bjørkeknapp",
  "block.minecraft.jungle_button": "jungeltreknapp",
  "block.minecraft.acacia_button": "akasieknapp",
  "block.minecraft.dark_oak_button": "mørkeikeknapp",
  "block.minecraft.crimson_button": "blodknapp",
  "block.minecraft.warped_button": "vriden knapp",
  "block.minecraft.polished_blackstone_button": "knapp av finpussa svartstein",
  "block.minecraft.anvil": "smieste",
  "block.minecraft.chipped_anvil": "sprokke smieste",
  "block.minecraft.damaged_anvil": "skadd smieste",
  "block.minecraft.trapped_chest": "lokkekiste",
  "block.minecraft.light_weighted_pressure_plate": "lett tyngdetrykkplate",
  "block.minecraft.heavy_weighted_pressure_plate": "tung tyngdetrykkplate",
  "block.minecraft.daylight_detector": "dagsljosmålar",
  "block.minecraft.redstone_block": "blokk av redstone",
  "block.minecraft.nether_quartz_ore": "malm av nether-kvarts",
  "block.minecraft.hopper": "trekt",
  "block.minecraft.chiseled_quartz_block": "forma kvarts",
  "block.minecraft.quartz_block": "blokk av kvarts",
  "block.minecraft.quartz_bricks": "kvartstegl",
  "block.minecraft.quartz_pillar": "kvartssøyle",
  "block.minecraft.quartz_stairs": "kvartstrapp",
  "block.minecraft.activator_rail": "aktivatorskjene",
  "block.minecraft.dropper": "sleppar",
  "block.minecraft.white_terracotta": "kvit terrakotta",
  "block.minecraft.orange_terracotta": "branngul terrakotta",
  "block.minecraft.magenta_terracotta": "ljoslilla terrakotta",
  "block.minecraft.light_blue_terracotta": "ljosblå terrakotta",
  "block.minecraft.yellow_terracotta": "gul terrakotta",
  "block.minecraft.lime_terracotta": "limegrøn terrakotta",
  "block.minecraft.pink_terracotta": "rosa terrakotta",
  "block.minecraft.gray_terracotta": "grå terrakotta",
  "block.minecraft.light_gray_terracotta": "ljosgrå terrakotta",
  "block.minecraft.cyan_terracotta": "blågrøn terrakotta",
  "block.minecraft.purple_terracotta": "lilla terrakotta",
  "block.minecraft.blue_terracotta": "blå terrakotta",
  "block.minecraft.brown_terracotta": "brun terrakotta",
  "block.minecraft.green_terracotta": "grøn terrakotta",
  "block.minecraft.red_terracotta": "raud terrakotta",
  "block.minecraft.black_terracotta": "svart terrakotta",
  "block.minecraft.barrier": "spelskjold",
  "block.minecraft.iron_trapdoor": "jarnlem",
  "block.minecraft.hay_block": "høystakk",
  "block.minecraft.white_carpet": "kvitt golvteppe",
  "block.minecraft.orange_carpet": "oransje golvteppe",
  "block.minecraft.magenta_carpet": "ljoslilla golvteppe",
  "block.minecraft.light_blue_carpet": "ljosblått golvteppe",
  "block.minecraft.yellow_carpet": "gult golvteppe",
  "block.minecraft.lime_carpet": "limegrønt golvteppe",
  "block.minecraft.pink_carpet": "rosa golvteppe",
  "block.minecraft.gray_carpet": "grått golvteppe",
  "block.minecraft.light_gray_carpet": "ljosgrått golvteppe",
  "block.minecraft.cyan_carpet": "blågrønt golvteppe",
  "block.minecraft.purple_carpet": "lilla golvteppe",
  "block.minecraft.blue_carpet": "blått golvteppe",
  "block.minecraft.brown_carpet": "brunt golvteppe",
  "block.minecraft.green_carpet": "grønt golvteppe",
  "block.minecraft.red_carpet": "raudt golvteppe",
  "block.minecraft.black_carpet": "svart golvteppe",
  "block.minecraft.terracotta": "terrakotta",
  "block.minecraft.coal_block": "kolblokk",
  "block.minecraft.packed_ice": "pakkis",
  "block.minecraft.acacia_stairs": "akasietrapp",
  "block.minecraft.dark_oak_stairs": "mørkeiketrapp",
  "block.minecraft.slime_block": "slimblokk",
  "block.minecraft.grass_path": "grasrås",
  "block.minecraft.sunflower": "solvendel",
  "block.minecraft.lilac": "syrin",
  "block.minecraft.rose_bush": "rosebusk",
  "block.minecraft.peony": "pion",
  "block.minecraft.tall_grass": "høgt gras",
  "block.minecraft.large_fern": "stor burkne",
  "block.minecraft.white_stained_glass": "kvitt glas",
  "block.minecraft.orange_stained_glass": "oransje glas",
  "block.minecraft.magenta_stained_glass": "ljoslilla glas",
  "block.minecraft.light_blue_stained_glass": "ljosblått glas",
  "block.minecraft.yellow_stained_glass": "gult glas",
  "block.minecraft.lime_stained_glass": "limegrønt glas",
  "block.minecraft.pink_stained_glass": "rosa glas",
  "block.minecraft.gray_stained_glass": "grått glas",
  "block.minecraft.light_gray_stained_glass": "ljosgrått glas",
  "block.minecraft.cyan_stained_glass": "blågrønt glas",
  "block.minecraft.purple_stained_glass": "lilla glas",
  "block.minecraft.blue_stained_glass": "blått glas",
  "block.minecraft.brown_stained_glass": "brunt glas",
  "block.minecraft.green_stained_glass": "grønt glas",
  "block.minecraft.red_stained_glass": "raudt glas",
  "block.minecraft.black_stained_glass": "svart glas",
  "block.minecraft.white_stained_glass_pane": "kvit glasrute",
  "block.minecraft.orange_stained_glass_pane": "oransje glasrute",
  "block.minecraft.magenta_stained_glass_pane": "ljoslilla glasrute",
  "block.minecraft.light_blue_stained_glass_pane": "ljosblå glasrute",
  "block.minecraft.yellow_stained_glass_pane": "gul glasrute",
  "block.minecraft.lime_stained_glass_pane": "limegrøn glasrute",
  "block.minecraft.pink_stained_glass_pane": "rosa glasrute",
  "block.minecraft.gray_stained_glass_pane": "grå glasrute",
  "block.minecraft.light_gray_stained_glass_pane": "ljosgrå glasrute",
  "block.minecraft.cyan_stained_glass_pane": "blågrøn glasrute",
  "block.minecraft.purple_stained_glass_pane": "lilla glasrute",
  "block.minecraft.blue_stained_glass_pane": "blå glasrute",
  "block.minecraft.brown_stained_glass_pane": "brun glasrute",
  "block.minecraft.green_stained_glass_pane": "grøn glasrute",
  "block.minecraft.red_stained_glass_pane": "raud glasrute",
  "block.minecraft.black_stained_glass_pane": "svart glasrute",
  "block.minecraft.prismarine": "prismarin",
  "block.minecraft.prismarine_bricks": "prismarintegl",
  "block.minecraft.dark_prismarine": "mørk prismarin",
  "block.minecraft.prismarine_stairs": "prismarintrapp",
  "block.minecraft.prismarine_brick_stairs": "prismarinmurtrapp",
  "block.minecraft.dark_prismarine_stairs": "mørk prismarintrapp",
  "block.minecraft.sea_lantern": "sjølykt",
  "block.minecraft.red_sandstone": "raud sandstein",
  "block.minecraft.chiseled_red_sandstone": "forma raud sandstein",
  "block.minecraft.cut_red_sandstone": "skoren raud sandstein",
  "block.minecraft.red_sandstone_stairs": "raud sandsteintrapp",
  "block.minecraft.repeating_command_block": "gjentakande kommandoblokk",
  "block.minecraft.chain_command_block": "kjedekommandoblokk",
  "block.minecraft.magma_block": "magmablokk",
  "block.minecraft.nether_wart_block": "vorteblokk",
  "block.minecraft.warped_wart_block": "vriden vorteblokk",
  "block.minecraft.red_nether_bricks": "raudt nethertegl",
  "block.minecraft.bone_block": "beinblokk",
  "block.minecraft.structure_void": "bygnadstomrom",
  "block.minecraft.observer": "utkikar",
  "block.minecraft.shulker_box": "shulkerboks",
  "block.minecraft.white_shulker_box": "kvit shulkerboks",
  "block.minecraft.orange_shulker_box": "oransje shulkerboks",
  "block.minecraft.magenta_shulker_box": "ljoslilla shulkerboks",
  "block.minecraft.light_blue_shulker_box": "ljosblå shulkerboks",
  "block.minecraft.yellow_shulker_box": "gul shulkerboks",
  "block.minecraft.lime_shulker_box": "limegrøn shulkerboks",
  "block.minecraft.pink_shulker_box": "rosa shulkerboks",
  "block.minecraft.gray_shulker_box": "grå shulkerboks",
  "block.minecraft.light_gray_shulker_box": "ljosgrå shulkerboks",
  "block.minecraft.cyan_shulker_box": "blågrøn shulkerboks",
  "block.minecraft.purple_shulker_box": "lilla shulkerboks",
  "block.minecraft.blue_shulker_box": "blå shulkerboks",
  "block.minecraft.brown_shulker_box": "brun shulkerboks",
  "block.minecraft.green_shulker_box": "grøn shulkerboks",
  "block.minecraft.red_shulker_box": "raud shulkerboks",
  "block.minecraft.black_shulker_box": "svart shulkerboks",
  "block.minecraft.white_glazed_terracotta": "kvit glasert terrakotta",
  "block.minecraft.orange_glazed_terracotta": "oransje glasert terrakotta",
  "block.minecraft.magenta_glazed_terracotta": "ljoslilla glasert terrakotta",
  "block.minecraft.light_blue_glazed_terracotta": "ljosblå glasert terrakotta",
  "block.minecraft.yellow_glazed_terracotta": "gul glasert terrakotta",
  "block.minecraft.lime_glazed_terracotta": "limegrøn glasert terrakotta",
  "block.minecraft.pink_glazed_terracotta": "rosa glasert terrakotta",
  "block.minecraft.gray_glazed_terracotta": "grå glasert terrakotta",
  "block.minecraft.light_gray_glazed_terracotta": "ljosgrå glasert terrakotta",
  "block.minecraft.cyan_glazed_terracotta": "blågrøn glasert terrakotta",
  "block.minecraft.purple_glazed_terracotta": "lilla glasert terrakotta",
  "block.minecraft.blue_glazed_terracotta": "blå glasert terrakotta",
  "block.minecraft.brown_glazed_terracotta": "brun glasert terrakotta",
  "block.minecraft.green_glazed_terracotta": "grøn glasert terrakotta",
  "block.minecraft.red_glazed_terracotta": "raud glasert terrakotta",
  "block.minecraft.black_glazed_terracotta": "svart glasert terrakotta",
  "block.minecraft.white_concrete": "kvit betong",
  "block.minecraft.orange_concrete": "oransje betong",
  "block.minecraft.magenta_concrete": "ljoslilla betong",
  "block.minecraft.light_blue_concrete": "ljosblå betong",
  "block.minecraft.yellow_concrete": "gul betong",
  "block.minecraft.lime_concrete": "limegrøn betong",
  "block.minecraft.pink_concrete": "rosa betong",
  "block.minecraft.gray_concrete": "grå betong",
  "block.minecraft.light_gray_concrete": "ljosgrå betong",
  "block.minecraft.cyan_concrete": "blågrøn betong",
  "block.minecraft.purple_concrete": "lilla betong",
  "block.minecraft.blue_concrete": "blå betong",
  "block.minecraft.brown_concrete": "brun betong",
  "block.minecraft.green_concrete": "grøn betong",
  "block.minecraft.red_concrete": "raud betong",
  "block.minecraft.black_concrete": "svart betong",
  "block.minecraft.white_concrete_powder": "kvitt betongpulver",
  "block.minecraft.orange_concrete_powder": "oransje betongpulver",
  "block.minecraft.magenta_concrete_powder": "ljoslilla betongpulver",
  "block.minecraft.light_blue_concrete_powder": "ljosblått betongpulver",
  "block.minecraft.yellow_concrete_powder": "gult betongpulver",
  "block.minecraft.lime_concrete_powder": "limegrønt betongpulver",
  "block.minecraft.pink_concrete_powder": "rosa betongpulver",
  "block.minecraft.gray_concrete_powder": "grått betongpulver",
  "block.minecraft.light_gray_concrete_powder": "ljosgrått betongpulver",
  "block.minecraft.cyan_concrete_powder": "blågrønt betongpulver",
  "block.minecraft.purple_concrete_powder": "lilla betongpulver",
  "block.minecraft.blue_concrete_powder": "blått betongpulver",
  "block.minecraft.brown_concrete_powder": "brunt betongpulver",
  "block.minecraft.green_concrete_powder": "grønt betongpulver",
  "block.minecraft.red_concrete_powder": "raudt betongpulver",
  "block.minecraft.black_concrete_powder": "svart betongpulver",
  "block.minecraft.turtle_egg": "skjelpaddeegg",
  "block.minecraft.dead_tube_coral_block": "daud orgelkorallblokk",
  "block.minecraft.dead_brain_coral_block": "daud hjernekorallblokk",
  "block.minecraft.dead_bubble_coral_block": "daud boblekorallblokk",
  "block.minecraft.dead_fire_coral_block": "daud eldkorallblokk",
  "block.minecraft.dead_horn_coral_block": "daud hornkorallblokk",
  "block.minecraft.tube_coral_block": "orgelkorallblokk",
  "block.minecraft.brain_coral_block": "hjernekorallblokk",
  "block.minecraft.bubble_coral_block": "boblekorallblokk",
  "block.minecraft.fire_coral_block": "eldkorallblokk",
  "block.minecraft.horn_coral_block": "hornkorallblokk",
  "block.minecraft.tube_coral": "orgelkorall",
  "block.minecraft.brain_coral": "hjernekorall",
  "block.minecraft.bubble_coral": "boblekorall",
  "block.minecraft.fire_coral": "eldkorall",
  "block.minecraft.horn_coral": "hornkorall",
  "block.minecraft.dead_brain_coral": "daud hjernekorall",
  "block.minecraft.dead_bubble_coral": "daud boblekorall",
  "block.minecraft.dead_fire_coral": "daud eldkorall",
  "block.minecraft.dead_horn_coral": "daud hornkorall",
  "block.minecraft.dead_tube_coral": "daud orgelkorall",
  "block.minecraft.tube_coral_fan": "orgelkorallvifte",
  "block.minecraft.brain_coral_fan": "hjernekorallvifte",
  "block.minecraft.bubble_coral_fan": "boblekorallvifte",
  "block.minecraft.fire_coral_fan": "eldkorallvifte",
  "block.minecraft.horn_coral_fan": "hornkorallvifte",
  "block.minecraft.dead_tube_coral_fan": "daud orgelkorallvifte",
  "block.minecraft.dead_brain_coral_fan": "daud hjernkorallvifte",
  "block.minecraft.dead_bubble_coral_fan": "daud boblekorallvifte",
  "block.minecraft.dead_fire_coral_fan": "daud eldkorallvifte",
  "block.minecraft.dead_horn_coral_fan": "daud hornkorallvifte",
  "block.minecraft.blue_ice": "blåis",
  "block.minecraft.conduit": "flødar",
  "block.minecraft.polished_granite_stairs": "finpussa granittrapp",
  "block.minecraft.smooth_red_sandstone_stairs": "glatt raud sandsteinstrapp",
  "block.minecraft.mossy_stone_brick_stairs": "mosegrodd trapp av steintegl",
  "block.minecraft.polished_diorite_stairs": "finpussa diorittrapp",
  "block.minecraft.mossy_cobblestone_stairs": "mosegrodd brusteinstrapp",
  "block.minecraft.end_stone_brick_stairs": "trapp av endesteinstegl",
  "block.minecraft.stone_stairs": "steintrapp",
  "block.minecraft.smooth_sandstone_stairs": "glatt sandsteinstrapp",
  "block.minecraft.smooth_quartz_stairs": "glatt kvartstrapp",
  "block.minecraft.granite_stairs": "granittrapp",
  "block.minecraft.andesite_stairs": "andesittrapp",
  "block.minecraft.red_nether_brick_stairs": "trapp av raud nethertegl",
  "block.minecraft.polished_andesite_stairs": "finpussa andesittrapp",
  "block.minecraft.diorite_stairs": "diorittrapp",
  "block.minecraft.polished_granite_slab": "finpussa granitthelle",
  "block.minecraft.smooth_red_sandstone_slab": "glatt raud sandsteinshelle",
  "block.minecraft.mossy_stone_brick_slab": "mosegrodd helle av steintegl",
  "block.minecraft.polished_diorite_slab": "finpussa dioritthelle",
  "block.minecraft.mossy_cobblestone_slab": "mosegrodd brusteinshelle",
  "block.minecraft.end_stone_brick_slab": "helle av endesteinstegl",
  "block.minecraft.smooth_sandstone_slab": "helle av glatt sandstein",
  "block.minecraft.smooth_quartz_slab": "helle av glatt kvart",
  "block.minecraft.granite_slab": "granitthelle",
  "block.minecraft.andesite_slab": "andesitthelle",
  "block.minecraft.red_nether_brick_slab": "helle av raud nethertegl",
  "block.minecraft.polished_andesite_slab": "helle av finpussa andesitt",
  "block.minecraft.diorite_slab": "dioritthelle",
  "block.minecraft.scaffolding": "stelling",
  "block.minecraft.iron_door": "jarndør",
  "block.minecraft.oak_door": "eikedør",
  "block.minecraft.spruce_door": "grandør",
  "block.minecraft.birch_door": "bjørkedør",
  "block.minecraft.jungle_door": "jungeltredør",
  "block.minecraft.acacia_door": "akasiedør",
  "block.minecraft.dark_oak_door": "mørkeikedør",
  "block.minecraft.crimson_door": "bloddør",
  "block.minecraft.warped_door": "vriden dør",
  "block.minecraft.repeater": "redstone-aukar",
  "block.minecraft.comparator": "redstone-samanliknar",
  "block.minecraft.structure_block": "bygnadsblokk",
  "block.minecraft.jigsaw": "pusleblokk",
  "item.minecraft.turtle_helmet": "skjelpaddeskal□□når på hovudet:□+2 rustning",
  "item.minecraft.scute": "skjel",
  "item.minecraft.iron_shovel": "jarnspade□□når i hovudhanda:□+3.5 skade□-3 åtakssnøggleik",
  "item.minecraft.iron_pickaxe": "jarnhakke□□når i hovudhanda:□+3 skade□-2.8 åtakssnøggleik",
  "item.minecraft.iron_axe": "jarnøks□□når i hovudhanda:□+8 skade□-3.1 åtakssnøggleik",
  "item.minecraft.flint_and_steel": "eldjarn",
  "item.minecraft.apple": "eple",
  "item.minecraft.bow": "boge",
  "item.minecraft.arrow": "pil",
  "item.minecraft.coal": "kol",
  "item.minecraft.charcoal": "trekol",
  "item.minecraft.diamond": "diamant",
  "item.minecraft.iron_ingot": "jarnbarre",
  "item.minecraft.gold_ingot": "gullbarre",
  "item.minecraft.netherite_ingot": "netherittbarre",
  "item.minecraft.netherite_scrap": "netherittskrap",
  "item.minecraft.iron_sword": "jarnsverd□□når i hovudhanda:□+5 skade□-2.4 åtakssnøggleik",
  "item.minecraft.wooden_sword": "tresverd□□når i hovudhanda:□+3 skade□-2.4 åtakssnøggleik",
  "item.minecraft.wooden_shovel": "trespade□□når i hovudhanda:□+1.5 skade□-3 åtakssnøggleik",
  "item.minecraft.wooden_pickaxe": "trehakke□□når i hovudhanda:□+1 skade□-2.8 åtakssnøggleik",
  "item.minecraft.wooden_axe": "treøks□□når i hovudhanda:□+6 skade□-3.2 åtakssnøggleik",
  "item.minecraft.stone_sword": "steinsverd□□når i hovudhanda:□+4 skade□-2.4 åtakssnøggleik",
  "item.minecraft.stone_shovel": "steinspade□□når i hovudhanda:□+2.5 skade□-3 åtakssnøggleik",
  "item.minecraft.stone_pickaxe": "steinhakke□□når i hovudhanda:□+2 skade□-2.8 åtakssnøggleik",
  "item.minecraft.stone_axe": "steinøks□□når i hovudhanda:□+8 skade□-3.2 åtakssnøggleik",
  "item.minecraft.diamond_sword": "diamantsverd□□når i hovudhanda:□+6 skade□-2.4 åtakssnøggleik",
  "item.minecraft.diamond_shovel": "diamantspade□□når i hovudhanda:□+4.5 skade□-3 åtakssnøggleik",
  "item.minecraft.diamond_pickaxe": "diamanthakke□□når i hovudhanda:□+4 skade□-2.8 åtakssnøggleik",
  "item.minecraft.diamond_axe": "diamantøks□□når i hovudhanda:□+8 skade□-3 åtakssnøggleik",
  "item.minecraft.stick": "pinne",
  "item.minecraft.bowl": "bolle",
  "item.minecraft.mushroom_stew": "soppstuing",
  "item.minecraft.golden_sword": "gullsverd□□når i hovudhanda:□+3 skade□-2.4 åtakssnøggleik",
  "item.minecraft.golden_shovel": "gullspade□□når i hovudhanda:□+1.5 skade□-3 åtakssnøggleik",
  "item.minecraft.golden_pickaxe": "gullhakke□□når i hovudhanda:□+1 skade□-2.8 åtakssnøggleik",
  "item.minecraft.golden_axe": "gulløks□□når i hovudhanda:□+6 skade□-3 åtakssnøggleik",
  "item.minecraft.netherite_sword": "netherittsverd□□når i hovudhanda:□+7 skade□-2.4 åtakssnøggleik",
  "item.minecraft.netherite_shovel": "netherittspade□□når i hovudhanda:□+5.5 skade□-3 åtakssnøggleik",
  "item.minecraft.netherite_pickaxe": "netheritthakke□□når i hovudhanda:□+5 skade□-2.8 åtakssnøggleik",
  "item.minecraft.netherite_axe": "netherittøks□□når i hovudhanda:□+9 skade□-3 åtakssnøggleik",
  "item.minecraft.string": "tråd",
  "item.minecraft.feather": "fjør",
  "item.minecraft.gunpowder": "krut",
  "item.minecraft.wooden_hoe": "tregrev□□når i hovudhanda:□-3 åtakssnøggleik",
  "item.minecraft.stone_hoe": "steingrev□□når i hovudhanda:□-2 åtakssnøggleik",
  "item.minecraft.iron_hoe": "jarngrev□□når i hovudhanda:□-1 åtakssnøggleik",
  "item.minecraft.diamond_hoe": "diamantgrev□□når i hovudhanda:",
  "item.minecraft.golden_hoe": "gullgrev□□når i hovudhanda:□-3 åtakssnøggleik",
  "item.minecraft.netherite_hoe": "netherittljå□□når i hovudhanda:",
  "item.minecraft.wheat_seeds": "kveitefrø",
  "item.minecraft.wheat": "kveite",
  "item.minecraft.bread": "brød",
  "item.minecraft.leather_helmet": "skinnhuve□□når på hovudet:□+1 rustning",
  "item.minecraft.leather_chestplate": "skinntrøye□□når på kroppen:□+3 rustning",
  "item.minecraft.leather_leggings": "skinnbrok□□når på beina:□+2 rustning",
  "item.minecraft.leather_boots": "skinnstøvlar□□når på føtene:□+1 rustning",
  "item.minecraft.chainmail_helmet": "brynjehette□□når på hovudet:□+2 rustning",
  "item.minecraft.chainmail_chestplate": "ringbrynje□□når på kroppen:□+5 rustning",
  "item.minecraft.chainmail_leggings": "brynjehose□□når på beina:□+4 rustning",
  "item.minecraft.chainmail_boots": "brynjestøvlar□□når på føtene:□+1 rustning",
  "item.minecraft.iron_helmet": "jarnhjelm□□når på hovudet:□+2 rustning",
  "item.minecraft.iron_chestplate": "brystplate av jarn□□når på kroppen:□+6 rustning",
  "item.minecraft.iron_leggings": "beinplater av jarn□□når på beina:□+5 rustning",
  "item.minecraft.iron_boots": "jarnstøvlar□□når på føtene:□+2 rustning",
  "item.minecraft.diamond_helmet": "diamanthjelm□□når på hovudet:□+3 rustning□+2 rustningsstyrke",
  "item.minecraft.diamond_chestplate": "brystplate av diamant□□når på kroppen:□+8 rustning□+2 rustningsstyrke",
  "item.minecraft.diamond_leggings": "beinplater av diamant□□når på beina:□+6 rustning□+2 rustningsstyrke",
  "item.minecraft.diamond_boots": "diamantstøvlar□□når på føtene:□+3 rustning□+2 rustningsstyrke",
  "item.minecraft.golden_helmet": "gullhjelm□□når på hovudet:□+2 rustning",
  "item.minecraft.golden_chestplate": "brystplate av gull□□når på kroppen:□+5 rustning",
  "item.minecraft.golden_leggings": "beinplater av gull□□når på beina:□+3 rustning",
  "item.minecraft.golden_boots": "gullstøvlar□□når på føtene:□+1 rustning",
  "item.minecraft.netherite_helmet": "netheritthjelm□□når på hovudet:□+3 rustning□+3 rustningsstyrke□+1 motstand mot attendeslag",
  "item.minecraft.netherite_chestplate": "brystplate av netheritt□□når på kroppen:□+8 rustning□+3 rustningsstyrke□+1 motstand mot attendeslag",
  "item.minecraft.netherite_leggings": "beinplater av netheritt□□når på beina:□+6 rustning□+3 rustningsstyrke□+1 motstand mot attendeslag",
  "item.minecraft.netherite_boots": "netherittskor□□når på føtene:□+3 rustning□+3 rustningsstyrke□+1 motstand mot attendeslag",
  "item.minecraft.flint": "flint",
  "item.minecraft.porkchop": "rå svinekotelett",
  "item.minecraft.cooked_porkchop": "steikt svinekotelett",
  "item.minecraft.painting": "målarstykke",
  "item.minecraft.golden_apple": "gulleple",
  "item.minecraft.enchanted_golden_apple": "trollbunde gulleple",
  "block.minecraft.oak_sign": "eikeskilt",
  "block.minecraft.spruce_sign": "granskilt",
  "block.minecraft.birch_sign": "bjørkeskilt",
  "block.minecraft.jungle_sign": "jungeltreskilt",
  "block.minecraft.acacia_sign": "akasieskilt",
  "block.minecraft.dark_oak_sign": "mørkeikeskilt",
  "block.minecraft.crimson_sign": "blodskilt",
  "block.minecraft.warped_sign": "vride skilt",
  "item.minecraft.bucket": "bytte",
  "item.minecraft.water_bucket": "vassbytte",
  "item.minecraft.lava_bucket": "lavabytte",
  "item.minecraft.minecart": "gruvevogn",
  "item.minecraft.saddle": "sâl",
  "item.minecraft.redstone": "redstone-pulver",
  "item.minecraft.snowball": "snøball",
  "item.minecraft.oak_boat": "trebåt av eik",
  "item.minecraft.leather": "lêr",
  "item.minecraft.milk_bucket": "mjølkebytte",
  "item.minecraft.pufferfish_bucket": "kulefiskebytte",
  "item.minecraft.salmon_bucket": "laksebytte",
  "item.minecraft.cod_bucket": "torskebytte",
  "item.minecraft.tropical_fish_bucket": "sudhavsfiskebytte",
  "item.minecraft.brick": "tegl",
  "item.minecraft.clay_ball": "leireball",
  "block.minecraft.dried_kelp_block": "blokk av turka tare",
  "item.minecraft.paper": "papir",
  "item.minecraft.book": "bok",
  "item.minecraft.slime_ball": "slimball",
  "item.minecraft.chest_minecart": "gruvevogn med kiste",
  "item.minecraft.furnace_minecart": "gruvevogn med omn",
  "item.minecraft.egg": "egg",
  "item.minecraft.compass": "kompass",
  "item.minecraft.fishing_rod": "fiskestong",
  "item.minecraft.clock": "klokke",
  "item.minecraft.glowstone_dust": "glødestøv",
  "item.minecraft.cod": "rå torsk",
  "item.minecraft.salmon": "rå laks",
  "item.minecraft.tropical_fish": "sudhavsfisk",
  "item.minecraft.pufferfish": "kulefisk",
  "item.minecraft.cooked_cod": "kokt torsk",
  "item.minecraft.cooked_salmon": "kokt laks",
  "item.minecraft.ink_sac": "blekkpose",
  "item.minecraft.red_dye": "raud let",
  "item.minecraft.green_dye": "grøn let",
  "item.minecraft.cocoa_beans": "kakaobønner",
  "item.minecraft.lapis_lazuli": "lasurstein",
  "item.minecraft.purple_dye": "lillalet",
  "item.minecraft.cyan_dye": "blågrønlet",
  "item.minecraft.light_gray_dye": "ljosgrålet",
  "item.minecraft.gray_dye": "grålet",
  "item.minecraft.pink_dye": "rosalet",
  "item.minecraft.lime_dye": "limegrønlet",
  "item.minecraft.yellow_dye": "gul let",
  "item.minecraft.light_blue_dye": "ljosblålet",
  "item.minecraft.magenta_dye": "ljoslillalet",
  "item.minecraft.orange_dye": "oransjelet",
  "item.minecraft.bone_meal": "beinmjøl",
  "item.minecraft.blue_dye": "blå let",
  "item.minecraft.brown_dye": "brun let",
  "item.minecraft.black_dye": "svart let",
  "item.minecraft.white_dye": "kvit let",
  "item.minecraft.bone": "bein",
  "item.minecraft.sugar": "sukker",
  "block.minecraft.cake": "kake",
  "block.minecraft.white_bed": "kvit seng",
  "block.minecraft.orange_bed": "oransje seng",
  "block.minecraft.magenta_bed": "ljoslilla seng",
  "block.minecraft.light_blue_bed": "ljosblå seng",
  "block.minecraft.yellow_bed": "gul seng",
  "block.minecraft.lime_bed": "limegrøn seng",
  "block.minecraft.pink_bed": "rosa seng",
  "block.minecraft.gray_bed": "grå seng",
  "block.minecraft.light_gray_bed": "ljosgrå seng",
  "block.minecraft.cyan_bed": "blågrøn seng",
  "block.minecraft.purple_bed": "lilla seng",
  "block.minecraft.blue_bed": "blå seng",
  "block.minecraft.brown_bed": "brun seng",
  "block.minecraft.green_bed": "grøn seng",
  "block.minecraft.red_bed": "raud seng",
  "block.minecraft.black_bed": "svart seng",
  "item.minecraft.cookie": "kjeks",
  "item.minecraft.filled_map": "kart□#0",
  "item.minecraft.shears": "saks",
  "item.minecraft.melon_slice": "melonbåt",
  "item.minecraft.dried_kelp": "turka tare",
  "item.minecraft.pumpkin_seeds": "graskarfrø",
  "item.minecraft.melon_seeds": "melonfrø",
  "item.minecraft.beef": "rå biff",
  "item.minecraft.cooked_beef": "steikt biff",
  "item.minecraft.chicken": "rå høne",
  "item.minecraft.cooked_chicken": "steikt høne",
  "item.minecraft.rotten_flesh": "ròte kjøt",
  "item.minecraft.ender_pearl": "endeperle",
  "item.minecraft.blaze_rod": "eldstav",
  "item.minecraft.ghast_tear": "ghasttåre",
  "item.minecraft.gold_nugget": "gullklump",
  "item.minecraft.nether_wart": "nethervorte",
  "item.minecraft.potion": "ulagbart brygg□ingen verknader",
  "item.minecraft.glass_bottle": "glasflaske",
  "item.minecraft.spider_eye": "vevkjerringauga",
  "item.minecraft.fermented_spider_eye": "ase vevkjerringsauga",
  "item.minecraft.blaze_powder": "eldpulver",
  "item.minecraft.magma_cream": "magmakrem",
  "block.minecraft.brewing_stand": "bryggjereiskap",
  "block.minecraft.cauldron": "gryte",
  "item.minecraft.ender_eye": "enderauga",
  "item.minecraft.glistering_melon_slice": "glitrande vassmelonbåt",
  "item.minecraft.bat_spawn_egg": "framkalleegg for skinnvengje",
  "item.minecraft.bee_spawn_egg": "framkalleegg for bie",
  "item.minecraft.blaze_spawn_egg": "framkalleegg for eldskrømt",
  "item.minecraft.cat_spawn_egg": "framkalleegg for katt",
  "item.minecraft.cave_spider_spawn_egg": "framkalleegg for hòlevevkjerring",
  "item.minecraft.chicken_spawn_egg": "framkalleegg for høne",
  "item.minecraft.cod_spawn_egg": "framkalleegg for torsk",
  "item.minecraft.cow_spawn_egg": "framkalleegg for ku",
  "item.minecraft.creeper_spawn_egg": "framkalleegg for creeper",
  "item.minecraft.dolphin_spawn_egg": "framkalleegg for delfin",
  "item.minecraft.donkey_spawn_egg": "framkalleegg for asen",
  "item.minecraft.drowned_spawn_egg": "framkalleegg for draug",
  "item.minecraft.elder_guardian_spawn_egg": "framkalleegg for eldre verjar",
  "item.minecraft.enderman_spawn_egg": "framkalleegg for endermann",
  "item.minecraft.endermite_spawn_egg": "framkalleegg for endermit",
  "item.minecraft.evoker_spawn_egg": "framkalleegg for åndemanar",
  "item.minecraft.fox_spawn_egg": "framkalleegg for rev",
  "item.minecraft.ghast_spawn_egg": "framkalleegg for ghast",
  "item.minecraft.guardian_spawn_egg": "framkalleegg for verjar",
  "item.minecraft.hoglin_spawn_egg": "framkalleegg for hoglin",
  "item.minecraft.horse_spawn_egg": "framkalleegg for hest",
  "item.minecraft.husk_spawn_egg": "framkalleegg for skaldauding",
  "item.minecraft.llama_spawn_egg": "framkalleegg for lama",
  "item.minecraft.magma_cube_spawn_egg": "framkalleegg for magmakube",
  "item.minecraft.mooshroom_spawn_egg": "framkalleegg for mooshroom",
  "item.minecraft.mule_spawn_egg": "framkalleegg for muldyr",
  "item.minecraft.ocelot_spawn_egg": "framkalleegg for ozelot",
  "item.minecraft.panda_spawn_egg": "framkalleegg for pandabjørn",
  "item.minecraft.parrot_spawn_egg": "framkalleegg for papegøye",
  "item.minecraft.phantom_spawn_egg": "framkalleegg for fantom",
  "item.minecraft.pig_spawn_egg": "framkalleegg for gris",
  "item.minecraft.piglin_spawn_egg": "framkalleegg for piglin",
  "item.minecraft.pillager_spawn_egg": "framkalleegg for plyndrar",
  "item.minecraft.polar_bear_spawn_egg": "framkalleegg for kvitebjørn",
  "item.minecraft.pufferfish_spawn_egg": "framkalleegg for kulefisk",
  "item.minecraft.rabbit_spawn_egg": "framkalleegg for hare",
  "item.minecraft.ravager_spawn_egg": "framkalleegg for herjar",
  "item.minecraft.salmon_spawn_egg": "framkalleegg for laks",
  "item.minecraft.sheep_spawn_egg": "framkalleegg for sau",
  "item.minecraft.shulker_spawn_egg": "framkalleegg for shulker",
  "item.minecraft.silverfish_spawn_egg": "framkalleegg for sylvkrek",
  "item.minecraft.skeleton_spawn_egg": "framkalleegg for beinrangel",
  "item.minecraft.skeleton_horse_spawn_egg": "framkalleegg for hestebeinrangel",
  "item.minecraft.slime_spawn_egg": "framkalleegg for sliming",
  "item.minecraft.spider_spawn_egg": "framkalleegg for vevkjerring",
  "item.minecraft.squid_spawn_egg": "framkalleegg for blekksprut",
  "item.minecraft.stray_spawn_egg": "framkalleegg for vandrar",
  "item.minecraft.strider_spawn_egg": "framkalleegg for stegar",
  "item.minecraft.trader_llama_spawn_egg": "framkalleegg for kjøpmannslama",
  "item.minecraft.tropical_fish_spawn_egg": "framkalleegg for sudhavsfisk",
  "item.minecraft.turtle_spawn_egg": "framkalleegg for skjelpadde",
  "item.minecraft.vex_spawn_egg": "framkalleegg for plageånd",
  "item.minecraft.villager_spawn_egg": "framkalleegg for bygdebu",
  "item.minecraft.vindicator_spawn_egg": "framkalleegg for forsvarar",
  "item.minecraft.wandering_trader_spawn_egg": "framkalleegg for farande kjøpmann",
  "item.minecraft.witch_spawn_egg": "framkalleegg for trollkjerring",
  "item.minecraft.wither_skeleton_spawn_egg": "framkalleegg for witherbeinrangel",
  "item.minecraft.wolf_spawn_egg": "framkalleegg for varg",
  "item.minecraft.zoglin_spawn_egg": "framkalleegg for zoglin",
  "item.minecraft.zombie_spawn_egg": "framkalleegg for dauding",
  "item.minecraft.zombie_horse_spawn_egg": "framkalleegg for hestedauding",
  "item.minecraft.zombie_villager_spawn_egg": "framkalleegg for bygdedauding",
  "item.minecraft.zombified_piglin_spawn_egg": "framkalleegg for piglindauding",
  "item.minecraft.experience_bottle": "galdreflaske",
  "item.minecraft.fire_charge": "eldkule",
  "item.minecraft.writable_book": "bok og fjørpenn",
  "item.minecraft.written_book": "skriven bok",
  "item.minecraft.emerald": "smaragd",
  "item.minecraft.item_frame": "ramme",
  "block.minecraft.flower_pot": "blomsterpotte",
  "item.minecraft.carrot": "gulrot",
  "item.minecraft.potato": "potet",
  "item.minecraft.baked_potato": "bakt potet",
  "item.minecraft.poisonous_potato": "giftig potet",
  "item.minecraft.map": "tomt kart",
  "item.minecraft.golden_carrot": "gullrot",
  "block.minecraft.skeleton_skull": "skalle av beinrangel",
  "block.minecraft.wither_skeleton_skull": "skalle av witherbeinrangel",
  "block.minecraft.player_head": "spelarhovud",
  "block.minecraft.zombie_head": "hovudskalle av dauding",
  "block.minecraft.creeper_head": "creeperhovud",
  "block.minecraft.dragon_head": "drakehovud",
  "item.minecraft.carrot_on_a_stick": "gulrot på stong",
  "item.minecraft.warped_fungus_on_a_stick": "vriden sopp på stong",
  "item.minecraft.nether_star": "netherstjerne",
  "item.minecraft.pumpkin_pie": "graskarpai",
  "item.minecraft.firework_rocket": "fyrverk",
  "item.minecraft.firework_star": "fyrverkstjerne",
  "item.minecraft.enchanted_book": "galdrebok",
  "item.minecraft.nether_brick": "nethertegl",
  "item.minecraft.quartz": "nether-kvarts",
  "item.minecraft.tnt_minecart": "gruvevogn med tnt",
  "item.minecraft.hopper_minecart": "gruvevogn med trekt",
  "item.minecraft.prismarine_shard": "prismarinskòr",
  "item.minecraft.prismarine_crystals": "prismarinkrystallar",
  "item.minecraft.rabbit": "rått harekjøt",
  "item.minecraft.cooked_rabbit": "steikt hare",
  "item.minecraft.rabbit_stew": "harestuing",
  "item.minecraft.rabbit_foot": "harelabb",
  "item.minecraft.rabbit_hide": "harefell",
  "item.minecraft.armor_stand": "rustningstativ",
  "item.minecraft.iron_horse_armor": "jarnrustning for hest",
  "item.minecraft.golden_horse_armor": "gullhesterustning",
  "item.minecraft.diamond_horse_armor": "diamantrustning for hest",
  "item.minecraft.leather_horse_armor": "lêrhesterustning",
  "item.minecraft.lead": "band",
  "item.minecraft.name_tag": "namneskilt",
  "item.minecraft.command_block_minecart": "gruvevogn med kommandoblokk",
  "item.minecraft.mutton": "rått sauekjøt",
  "item.minecraft.cooked_mutton": "kokt sauekjøt",
  "block.minecraft.white_banner": "kvit fane",
  "block.minecraft.orange_banner": "oransje fane",
  "block.minecraft.magenta_banner": "ljoslilla fane",
  "block.minecraft.light_blue_banner": "ljosblå fane",
  "block.minecraft.yellow_banner": "gul fane",
  "block.minecraft.lime_banner": "limegrøn fane",
  "block.minecraft.pink_banner": "rosa fane",
  "block.minecraft.gray_banner": "grå fane",
  "block.minecraft.light_gray_banner": "ljosgrå fane",
  "block.minecraft.cyan_banner": "blågrøn fane",
  "block.minecraft.purple_banner": "lilla fane",
  "block.minecraft.blue_banner": "blå fane",
  "block.minecraft.brown_banner": "brun fane",
  "block.minecraft.green_banner": "grøn fane",
  "block.minecraft.red_banner": "raud fane",
  "block.minecraft.black_banner": "svart fane",
  "item.minecraft.end_crystal": "endekrystall",
  "item.minecraft.chorus_fruit": "korfrukt",
  "item.minecraft.popped_chorus_fruit": "sprungen korfrukt",
  "item.minecraft.beetroot": "raudbete",
  "item.minecraft.beetroot_seeds": "raudbetefrø",
  "item.minecraft.beetroot_soup": "raudbetesuppe",
  "item.minecraft.dragon_breath": "drakeande",
  "item.minecraft.splash_potion": "ulagbart kastebrygg□ingen verknader",
  "item.minecraft.spectral_arrow": "merkingspil",
  "item.minecraft.tipped_arrow": "ulagbar duppa pil□ingen verknader",
  "item.minecraft.lingering_potion": "dvelande ulageleg brygg□ingen verknader",
  "item.minecraft.shield": "skjold",
  "item.minecraft.elytra": "venger",
  "item.minecraft.spruce_boat": "trebåt av gran",
  "item.minecraft.birch_boat": "trebåt av bjørk",
  "item.minecraft.jungle_boat": "trebåt av jungeltre",
  "item.minecraft.acacia_boat": "trebåt av akasie",
  "item.minecraft.dark_oak_boat": "trebåt av mørkeik",
  "item.minecraft.totem_of_undying": "totem mot døying",
  "item.minecraft.shulker_shell": "shulkerskal",
  "item.minecraft.iron_nugget": "jarnklump",
  "item.minecraft.knowledge_book": "kunnebok",
  "item.minecraft.debug_stick": "avlusarpinne",
  "item.minecraft.music_disc_13": "musikkplate□c418 - 13",
  "item.minecraft.music_disc_cat": "musikkplate□c418 - cat",
  "item.minecraft.music_disc_blocks": "musikkplate□c418 - blocks",
  "item.minecraft.music_disc_chirp": "musikkplate□c418 - chirp",
  "item.minecraft.music_disc_far": "musikkplate□c418 - far",
  "item.minecraft.music_disc_mall": "musikkplate□c418 - mall",
  "item.minecraft.music_disc_mellohi": "musikkplate□c418 - mellohi",
  "item.minecraft.music_disc_stal": "musikkplate□c418 - stal",
  "item.minecraft.music_disc_strad": "musikkplate□c418 - strad",
  "item.minecraft.music_disc_ward": "musikkplate□c418 - ward",
  "item.minecraft.music_disc_11": "musikkplate□c418 - 11",
  "item.minecraft.music_disc_wait": "musikkplate□c418 - wait",
  "item.minecraft.music_disc_pigstep": "musikkplate□lena raine - pigstep",
  "item.minecraft.trident": "lyster□□når i hovudhanda:□+8 skade□-2.9 åtakssnøggleik",
  "item.minecraft.phantom_membrane": "fantomhinne",
  "item.minecraft.nautilus_shell": "perlebåtskal",
  "item.minecraft.heart_of_the_sea": "havhjarta",
  "item.minecraft.crossbow": "armbrøst",
  "item.minecraft.suspicious_stew": "tvilsam stuing",
  "block.minecraft.loom": "vevstol",
  "item.minecraft.flower_banner_pattern": "fanemønster□blome",
  "item.minecraft.creeper_banner_pattern": "fanemønster□creeper",
  "item.minecraft.skull_banner_pattern": "fanemønster□skalle",
  "item.minecraft.mojang_banner_pattern": "fanemønster□ting",
  "item.minecraft.globe_banner_pattern": "fanemønster□klote",
  "item.minecraft.piglin_banner_pattern": "fanemønster□snut",
  "block.minecraft.composter": "kompostbing",
  "block.minecraft.barrel": "tunne",
  "block.minecraft.smoker": "røykjaromn",
  "block.minecraft.blast_furnace": "smelteomn",
  "block.minecraft.cartography_table": "kartteiknarbord",
  "block.minecraft.fletching_table": "pilmakarbord",
  "block.minecraft.grindstone": "slipestein",
  "block.minecraft.lectern": "talarstol",
  "block.minecraft.smithing_table": "smiebord",
  "block.minecraft.stonecutter": "steinskjerar",
  "block.minecraft.bell": "bjølle",
  "block.minecraft.lantern": "lykt",
  "block.minecraft.soul_lantern": "sjeleljos",
  "item.minecraft.sweet_berries": "søtbær",
  "block.minecraft.campfire": "bål",
  "block.minecraft.soul_campfire": "sjelebål",
  "block.minecraft.shroomlight": "lampinjong",
  "item.minecraft.honeycomb": "vokskake",
  "block.minecraft.bee_nest": "biebol",
  "block.minecraft.beehive": "biekube",
  "item.minecraft.honey_bottle": "honningflaske",
  "block.minecraft.honey_block": "honningblokk",
  "block.minecraft.honeycomb_block": "vokskakeblokk",
  "block.minecraft.lodestone": "leidarstein",
  "block.minecraft.netherite_block": "netherittblokk",
  "block.minecraft.ancient_debris": "forne leivder",
  "block.minecraft.target": "skotskive",
  "block.minecraft.crying_obsidian": "gråtande obsidian",
  "block.minecraft.blackstone": "svartstein",
  "block.minecraft.blackstone_slab": "svartsteinshelle",
  "block.minecraft.blackstone_stairs": "svartsteinstrapp",
  "block.minecraft.gilded_blackstone": "gylt svartstein",
  "block.minecraft.polished_blackstone": "finpussa svartstein",
  "block.minecraft.polished_blackstone_slab": "helle av finpussa svartstein",
  "block.minecraft.polished_blackstone_stairs": "trapp av finpussa svartstein",
  "block.minecraft.chiseled_polished_blackstone": "forma finpussa svartstein",
  "block.minecraft.polished_blackstone_bricks": "finpussa svartsteinstegl",
  "block.minecraft.polished_blackstone_brick_slab": "helle av finpussa svartsteinstegl",
  "block.minecraft.polished_blackstone_brick_stairs": "trapp av finpussa svartsteinstegl",
  "block.minecraft.cracked_polished_blackstone_bricks": "sprokke finpussa svartsteinstegl",
  "block.minecraft.respawn_anchor": "oppstodeanker",
}
export const nn_no = items; 
